// No need for hardcoding, values are all in correct order
const numDesigns = 14;
const classic = [];

for ( let i = 0; i < numDesigns; i++ ) {
  const number = 99 + i;
  classic.push( {
    number: `HC${number}`
  });
}

export default classic;